import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useAppProvider } from "../AppContext";
import { HistoryItem } from "./HistoryItem";
import { useEffect, useState } from "react";
import { StorageAPI } from "../storage";
import { Box, Grid, Link, ListSubheader, Typography } from "@mui/material";
import { getExplorerServiceUrl, getTxStatus, TxStatus } from "../api";
import { useInterval } from "usehooks-ts";

interface HistoryProps {}

function getTxStatusColor(status: string) {
  switch (status) {
    case TxStatus.initial:
      return "white";
    case TxStatus.pending:  
      return "yellow";
    case TxStatus.finished:
      return "green";
    case TxStatus.failed:
      return "red";
    default:
      return "white";
  }
}

export default function History(props: HistoryProps) {
  const { connected, network } = useAppProvider();

  const [_historyItems, setHistoryItems] = useState<HistoryItem[]>([]);

  useEffect(() => {
    setHistoryItems(StorageAPI.getAllHistoryItems(network));
  }, [network]);

  useInterval(
    () => {
      // Your custom logic here

      const items = StorageAPI.getAllHistoryItems(network)

      Promise.all(items.map(item => {

        if(item.status === TxStatus.invalid || item.status === TxStatus.finished) {
          return item
        }

        return getTxStatus(item.txId, network).then(status => {
          return Object.assign({}, item, {
            status
          })
        })
      }))
      .then((items) => {
        StorageAPI.updateAllHistoryItems(network, items);
        setHistoryItems(items)
      })
      .catch(e => {
        console.error('getTxStatus:', e)
      });
    },
    // Delay in milliseconds or null to stop it
    _historyItems.length > 0 ? 5000 : null
  );

  return (
    <List
      sx={{ width: "100%", maxWidth: 460, bgcolor: "background.paper",  }}
      subheader={
        <ListSubheader component="div" id="history-subheader">
          <ListItem key={"HEAD"}>
            <Grid container spacing={1}>
              <Grid item xs={2}>
                <Typography>Type: </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography>Symbol: </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography>Amount/LocalId: </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography>TxId: </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography>Status: </Typography>
              </Grid>
            </Grid>
          </ListItem>
        </ListSubheader>
      }
    >
      {connected() ? (
        _historyItems.map((item) => {
          return (

            <ListItem key={item.txId} divider={true}>
              {/* <ListItemAvatar>
                <Avatar>
                  <ImageIcon />
                </Avatar>
              </ListItemAvatar> */}

              <Grid container spacing={1}>
              <Grid item xs={2} >
                  <ListItemText 
                    primary={`${item.type}`} 
                  />
                </Grid>
                <Grid item xs={2}>
                  <ListItemText 
                    primary={`${item.symbol}`} 
                    primaryTypographyProps={{ 
                      style: { 
                        whiteSpace: 'nowrap', 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis', 
                      } 
                    }} 
                  />
                </Grid>
                <Grid item xs={4}>
                  <ListItemText primary={`${item.amountOrLocalId}`} 
                   primaryTypographyProps={{ 
                      style: { 
                        whiteSpace: 'nowrap', 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis', 
                      } 
                    }} />
                </Grid>
                <Grid item xs={2}>
                  <Box sx={{ mt: 0.5 }}>
                  <Link
                    href={`${getExplorerServiceUrl(network)}/tx/${item.txId}`}
                    rel="noopener noreferrer"
                    mt={0}
                    target="_blank"
                    variant="body2"
                  >
                    {item.txId.substring(0, 6) + "..."}
                  </Link>
                    </Box>

                </Grid>
                <Grid item xs={2}>
                  <ListItemText 
                    primary={`${item.status}`} 
                    primaryTypographyProps={{ 
                      style: { color: getTxStatusColor(item.status) } 
                    }} 
                  />
                </Grid>
              </Grid>
            </ListItem>
          );
        })
      ) : (
        <></>
      )}
    </List>
  );
}
